import React from 'react';
import FindItActivityProgress from '@monorepo/shared/src/components/activities/FindItActivityProgress';
import HintButton from '@monorepo/shared/src/components/modules/Paging/components/HintButton';
import makeStyles from '@mui/styles/makeStyles';
import { ActivityTypes } from '@monorepo/shared/src/providers/GameProvider/types';

const FindTheObjectFooter: React.FC = () => {
  const classes = useStyles();
  return (
    <>
      <FindItActivityProgress activityType={ActivityTypes.FIND_THE_OBJECTS} />
      <div className={classes.footerControls}>
        <HintButton />
      </div>
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  footerControls: {
    position: 'absolute',
    display: 'flex',
    gridGap: '1rem',
    right: theme.constants.app.paddingX,
    alignItems: 'flex-end',
    bottom: '2rem',
    zIndex: 2,
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column-reverse',
    },
  },
}));

export default FindTheObjectFooter;
